import { Link } from 'react-router-dom';
import { Heart, FileText } from 'lucide-react';
import LanguageSwitcher from '../components/LanguageSwitcher';
import SEOHead from '../components/SEOHead';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <SEOHead title="Refund Policy" description="LusoLove refund policy. Learn about our refund terms for premium subscriptions." path="/refund" />
      {/* Header */}
      <header className="fixed top-0 w-full z-50 backdrop-blur-xl bg-[#FAF9F6]/90 border-b border-[#E5E3DB]/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo">
            <Heart className="w-7 h-7 text-[#6E1A24] group-hover:scale-110 transition-transform" strokeWidth={1.5} fill="currentColor" fillOpacity={0.1} />
            <span className="text-xl font-serif font-medium text-[#2D2D2A]">LusoLove</span>
          </Link>
          <LanguageSwitcher />
        </div>
      </header>

      {/* Content */}
      <div className="pt-28 pb-20 px-4 sm:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-2xl bg-[#6E1A24]/10 flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#6E1A24]" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-serif font-light text-[#2D2D2A]" data-testid="refund-title">
                Refund Policy
              </h1>
            </div>
          </div>

          <div className="space-y-6">
            <p className="text-[#6C6C67] leading-relaxed">
              All purchases are non-refundable unless required by applicable law.
            </p>

            <p className="text-[#6C6C67] leading-relaxed">
              If you experience any issue with your subscription, please contact our support at{' '}
              <a href="mailto:contact@lusolove.com" className="text-[#6E1A24] hover:underline font-medium" data-testid="refund-contact-link">
                contact@lusolove.com
              </a>.
            </p>

            <p className="text-[#6C6C67] leading-relaxed">
              We reserve the right to review refund requests on a case-by-case basis.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 bg-[#2D2D2A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-12 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <Heart className="w-6 h-6 text-[#C97A63]" strokeWidth={1.5} fill="currentColor" fillOpacity={0.3} />
            <span className="text-xl font-serif">LusoLove</span>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-white/60">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
            <Link to="/refund" className="hover:text-white transition-colors">Refund Policy</Link>
            <Link to="/faq" className="hover:text-white transition-colors">FAQ</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
          </div>
          <p className="text-sm text-white/40">Made in Portugal, with love.</p>
        </div>
      </footer>
    </div>
  );
}
